<template>
    <div v-if="cruise.found" class="width100" id="info_prijzen">
        <div class="clear"></div>
        <div class="shadow width100 marginbottom15 ultralichtblauwbg">
            <div class="padding20 lineheight22">
                <div class="width100">
                    <h3 class="nomargin midblauw marginbottom10 font18">
                        Data &amp; prijzen
                    </h3>
                    <p class="nomargin lineheight22">
                        In 3 simpele stappen kan je jouw cruise vakantie geheel
                        aankleden.<br />
                        Heb je hulp nodig bij het samenstellen van je ideale
                        cruise vakantie?<br />
                        Neem dan contact met ons op via
                        <a href="tel:0107200500">
                            010 7200500
                        </a>
                        of mail naar
                        <a href="mailto:klantenservice@cruisereizen.nl">
                            klantenservice@cruisereizen.nl
                        </a>
                    </p>
                    <div class="clear marginbottom20"></div>

                    <CabinSetup :currentStep="1" />
                    <div class="clear marginbottom20"></div>

                    <RatesOverview :cruiseID="cruise.id" :currentStep="2" />
                    <div class="clear marginbottom20"></div>

                    <Cabins :currentStep="3" />
                    <div class="clear marginbottom20"></div>

                    <div v-if="false" class="vluchtenoverzicht">
                        <FlightSetup />
                        <div class="clear marginbottom20"></div>
                    </div>

                    <OfferInput :currentStep="4" />
                    <div class="clear marginbottom20"></div>
                </div>
            </div>
            <div class="clear floatleft"></div>
        </div>
    </div>
</template>

<script>
import RatesOverview from './RatesOverview.vue'
import Cabins from './Cabins.vue'
import OfferInput from './OfferInput.vue'
import CabinSetup from './CabinSetup.vue'

import FlightSetup from './FlightSetup.vue'

export default {
    name: 'offerStappen',
    components: {
        RatesOverview,
        Cabins,
        OfferInput,
        CabinSetup,
        FlightSetup,
    },
    props: {
        cruise: Object,
    },
    data: function() {
        return {
            stepStart: 1,
        }
    },
    computed: {},
}
</script>
